import withRouter from "hoc-lib/router"
import { useEffect, useRef, useState } from "react"
import { makeStyles } from "tss-react/mui"
import { ReactSVG } from "react-svg"
import getContentUrl from "utils-lib/getContentUrl"
import { handleEnterPress } from "utils-lib/handleEnterPress"
import { KEY_CODE_MAPPING } from "constants-lib/keyCodes"
import { Button, Link } from "../../../../../Base"
import NextImageWrapper from "../../../../../SSR/NextImageWrapper"

const closeIcon = getContentUrl(
  "/content/dam/wm/icons/controls/20x20/green1/material-ui/arrow-up.svg",
)
const openIcon = getContentUrl(
  "/content/dam/wm/icons/controls/20x20/green1/material-ui/arrow-down.svg",
)

const useStyles = makeStyles()(() => ({
  supportButton: {
    cursor: `pointer`,
    position: `relative`,
    outline: `none`,
    "&:focus": {
      outline: `2px auto -webkit-focus-ring-color`,
    },
  },
  supportDropdownInner: {
    background: `white`,
    boxShadow: `0px 4px 8px rgba(0, 0, 0, 0.2), 0px 0.5px 1px rgba(0, 0, 0, 0.1)`,
    cursor: `pointer`,
    position: `absolute`,
    top: `2.5rem`,
    width: `12rem`,
    zIndex: 101,
    outline: `none`,
    left: `-2rem`,
    padding: `0.5rem`,
  },
  link: {
    padding: `0.5rem 0 !important`,
    "&:focus": {
      outline: `2px auto -webkit-focus-ring-color !important`,
    },
  },
}))

const SupportDropdown = ({ showCaret, label, links }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { classes } = useStyles()
  const dropdownRef = useRef(null)
  const optionRefs = {
    0: useRef(null),
    1: useRef(null),
    2: useRef(null),
  }

  useEffect(() => {
    if (isOpen && optionRefs[0]?.current) {
      optionRefs[0]?.current?.focus()
    }
  }, [isOpen])

  const openDropdown = (e) => {
    if (dropdownRef?.current?.contains(e.target) && isOpen) {
      setIsOpen(false)
    } else {
      setIsOpen(true)
    }
  }

  const handleKeyPress = (e) => {
    handleEnterPress(e, () => setIsOpen((prevState) => !prevState))
    if (e.keyCode === KEY_CODE_MAPPING.ESCAPE && isOpen) {
      setIsOpen(false)
    }
  }

  const renderDropdown = () => {
    if (!isOpen) {
      return null
    }

    return (
      <div
        className={`SupportDropdown_inner ${classes.supportDropdownInner}`}
        role="listbox"
      >
        {links.map((link) => (
          <Link
            key={link.label}
            href={link.url}
            className={`maax-font-weight-bold ${classes.link}`}
            isExternalLink={link.isExternalLink}
          >
            {link.label}
          </Link>
        ))}
      </div>
    )
  }

  return (
    <div
      tabIndex={-1}
      onBlur={(e) => {
        if (!dropdownRef.current.contains(e.relatedTarget)) {
          setIsOpen(false)
        }
      }}
    >
      <Button
        id="supportButton"
        data-testid="supportButton"
        ariaLabel="Need Help?"
        type="button"
        onClick={openDropdown}
        onKeyDown={handleKeyPress}
        overrideClass={classes.supportButton}
        role="listbox"
      >
        <div ref={dropdownRef} className="d-flex align-items-center">
          {renderDropdown()}
          <div className="maax-font-weight-bold rounded-0 d-flex flex-column align-items-center justify-content-center has-focus">
            {label}
          </div>
          {showCaret && (
            <NextImageWrapper
              wrapper="span"
              src={isOpen ? closeIcon : openIcon}
              alt={isOpen ? "open icon" : "close icon"}
              nextImageProps={{
                height: 18,
                width: 18,
                loading: "eager",
              }}
              renderLegacyComponent={(props) => <ReactSVG {...props} />}
            />
          )}
        </div>
      </Button>
    </div>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// SupportDropdown.propTypes = {
//   showCaret: PropTypes.bool.isRequired,
//   label: PropTypes.string.isRequired,
//   links: PropTypes.array.isRequired,
// }

export default withRouter(SupportDropdown)
